/**
 * Local-zone `YYYY-MM-DD-HH-MM` timestamp for CSV-export filenames (LR-469).
 *
 * Built entirely from LOCAL getters — NOT `toISOString()`, which returns the UTC day
 * and, near local midnight for a non-UTC user, disagrees with the local HH-MM stamped
 * beside it (an off-by-one date in the filename). Shared by both the Trades and MTM
 * exporters so the two can't drift apart again.
 *
 * @param now injectable for tests (defaults to the current instant).
 */
export const csvFilenameStamp = (now: Date = new Date()): string => {
  const pad = (n: number): string => String(n).padStart(2, '0');
  const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const time = `${pad(now.getHours())}-${pad(now.getMinutes())}`;
  return `${date}-${time}`;
};
